import Avatar from './Avatar'
import type { AvatarProps } from './Avatar'

export type { AvatarProps }
export default Avatar
